import React from 'react';
import { Router, Route, Switch, NavLink } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import createHistory  from 'history/createBrowserHistory';
import ReactGA from 'react-ga'
import DashboardPage from '../components/DashboardPage';
import NotFoundPage from '../components/NotFoundPage';
import PrivateRoute  from './PrivateRoute';
import PublicRoute  from './PublicRoute';
import ScrollToTop from './ScrollToTop';
import HomePage from '../components/HomePage';
import SignUpPage from '../components/SignUpPage';
import LoginPage from '../components/LoginPage';
import ForgotPwPage from '../components/ForgotPwPage';
import ForgotPwPage2 from '../components/ForgotPwPage2';
import ResetPwPage from '../components/ResetPwPage';
import PicEventMgtPage from '../components/PicEventMgtPage';
import PicListStatuses from '../components/PicListStatuses';
// import PicEvent from '../components/PicEvent';
import PicInvitation from '../components/PicInvitation';
import PicInvitationMock  from '../components/PicInvitationMock';
// import VersionPage from '../pages/VersionPage';
// import Resources from '../components/Resources';
// import AboutUsPage from '../components/AboutUsPage';
import ContactFormPage from '../components/ContactFormPage';
import PrivacyPolicyPage from '../components/PrivacyPolicyPage';
// import TestChild from '../components/TestChild';
// import TestParent from '../components/TestParent';
// import About        from '../pages/About';
import Faq        from '../pages/Faq';
// import HomeFour        from '../pages/HomeFour';
// import HomeFive        from '../pages/HomeFive';
// import AboutPage        from '../components/AboutPage';
import getAppConfig   from '../config/AppConfig';
import ShareableLink  from '../components/links/ShareableLink';
// import Loadable from 'react-loadable';
import loadable from '@loadable/component'
import { faRampLoading } from '@fortawesome/pro-solid-svg-icons';

// <BrowserRouter> uses browser history by default. <BrowserRouter> allows you to 
// use history only on components registered as a route.  For an alternative, you  
// can use <Router>, and pass in your own history as a prop. Hence <BrowserRouter> 
// gets replaced with <Router history={history}> below. The result is the same. 
// The main advantage is being able to "export const history" and using it in other files, 
// specifically, those that are not registered as a route (eg  app.js).
//
export const history = createHistory();

// Code below listens to your routes history . Whenever route changes, 
// the page view will be logged by Google Analytics. The code will only run
// in production
let env = getAppConfig("env");
// if (env === 'dev' || env === 'test' || env === 'prod') {
if (env === 'prod') {
    history.listen(location => {
        ReactGA.set({ page: location.pathname })
        ReactGA.pageview(location.pathname)
    })
}

// Split out HomePage using react-loadable
// const LoadableHomePage = Loadable({
//   loader: () => import('../components/HomePage'),
//   loading() { 
//     return <div>Loading...</div>
//   }
// })

class AppRouter extends React.Component {
  
    componentDidMount() {
        /* only log pageview in Google Analytics for production */
        // if (env === 'dev' || env === 'test' || env === 'prod') {
        if (env === 'prod') {
            ReactGA.pageview(window.location.pathname)
        }
	}

    render() {
        return (
            <Router history={history}>   
            <ScrollToTop> 
                <div>
                    <Switch>
                        <PublicRoute path="/" component={HomePage} exact={true} />
                        <PublicRoute path="/test1" component={ShareableLink} />
                        <PublicRoute path="/login" component={LoginPage} />
                        <PublicRoute path="/signup" component={SignUpPage} />                
                        <PublicRoute path="/forgotpw" component={ForgotPwPage} />                
                        <PublicRoute path="/forgotpw2" component={ForgotPwPage2} />                
                        <PublicRoute path="/resetpw/:id/:token" component={ResetPwPage} />                
                        <PublicRoute path="/invitation/:token" component={PicInvitation} />
                        {/* <Route path="/resources" component={Resources} /> */}
                        {/* <Route path="/about-us" component={AboutUsPage} /> */}
                        <Route path="/contact-form" component={ContactFormPage} />
                        <Route path="/privacy-policy" component={PrivacyPolicyPage} />
                        {/*<Route path="/testchild" component={TestChild} />*/}
                        {/* <Route path="/testparent" component={TestParent} />*/}
                        {/* <Route path="/about" component={AboutPage} /> */}
                        {/* <Route path="/faq" component={Faq} /> */}
                        {/*<Route path="/home4" component={HomeFour} />*/}
                        {/*<Route path="/home5" component={HomeFive} />*/}
                        {/* <Route path="/about-us" component={AboutPage} /> */}
                        {/* <PublicRoute path="/version" component={VersionPage} /> */}     
                        <PrivateRoute path="/myinvitation/:id" component={PicInvitationMock} />
                        <PrivateRoute path="/liststatuses/:id" component={PicListStatuses} />
                        <PrivateRoute path="/dashboard" component={DashboardPage} />
                        <PrivateRoute path="/eventmanage/:value" component={PicEventMgtPage} />
                        {/*
                        <PrivateRoute path="/event/:id" component={PicEvent} /> */}
                        <Route component={NotFoundPage} />
                    </Switch>
                </div>
            </ScrollToTop> 
            </Router>
        ); 
    }
}

// This verison of the Router was in place before adding google analytics
// const AppRouter = () =>   (
//     <Router history={history}>   
//     <ScrollToTop> 
//         <div>
//             <Switch>
//                 <PublicRoute path="/" component={HomePage} exact={true} />
//                 <PublicRoute path="/login" component={LoginPage} />
//                 <PublicRoute path="/signup" component={SignUpPage} />                
//                 <PublicRoute path="/forgotpw" component={ForgotPwPage} />                
//                 <PublicRoute path="/forgotpw2" component={ForgotPwPage2} />                
//                 <PublicRoute path="/resetpw/:id/:token" component={ResetPwPage} />                
//                 <PublicRoute path="/invitation/:token" component={PicInvitation} />
//                 <Route path="/resources" component={Resources} />
//                 {/* <Route path="/about-us" component={AboutUsPage} /> */}
//                 <Route path="/contact-form" component={ContactFormPage} />
//                 <Route path="/privacy-policy" component={PrivacyPolicyPage} />
//                 <Route path="/testchild" component={TestChild} />
//                 <Route path="/testparent" component={TestParent} />
//                 {/* <Route path="/about" component={AboutPage} /> */}
//                 <Route path="/faq" component={Faq} />
//                 <Route path="/home4" component={HomeFour} />
//                 <Route path="/home5" component={HomeFive} />
//                 <Route path="/about-us" component={AboutPage} />
//                 <PublicRoute path="/version" component={VersionPage} />      
//                 <PrivateRoute path="/myinvitation/:id" component={PicInvitationMock} />
//                 <PrivateRoute path="/liststatuses/:id" component={PicListStatuses} />
//                 <PrivateRoute path="/dashboard" component={DashboardPage} />
//                 <PrivateRoute path="/eventmanage/:value" component={PicEventMgtPage} />
//                 {/*
//                 <PrivateRoute path="/event/:id" component={PicEvent} /> */}
//                 <Route component={NotFoundPage} />
//             </Switch>
//         </div>
//     </ScrollToTop> 
//     </Router>
// );


//
// Note that the <Route /> component that was replaced by <PrivateRoute> below, 
// now lives in PrivateRoute.js.  PrivateRoute.js renders a conditional Route and receives 
// the parms below as props from <PrivateRoute>.
// const AppRouter = () => (
//     <Router history={history}>   
//       <ScrollToTop> 
//         <div>
//             <Switch>
//                 <PublicRoute path="/" component={HomePage} exact={true} />
//                 <PublicRoute path="/login" component={LoginPage} />
//                 <PublicRoute path="/signup" component={SignUpPage} />                
//                 <PublicRoute path="/forgotpw" component={ForgotPwPage} />                
//                 <PublicRoute path="/forgotpw2" component={ForgotPwPage2} />                
//                 <PublicRoute path="/resetpw/:id/:token" component={ResetPwPage} />                
//                 <PublicRoute path="/invitation/:token" component={PicInvitation} />
//                 <Route path="/resources" component={Resources} />
//                 <Route path="/about-us" component={AboutUsPage} />
//                 <Route path="/contact-form" component={ContactFormPage} />
//                 <Route path="/privacy-policy" component={PrivacyPolicyPage} />
//                 <Route path="/testchild" component={TestChild} />
//                 <Route path="/testparent" component={TestParent} />
//                 <PublicRoute path="/version" component={VersionPage} />      
//                 <PrivateRoute path="/myinvitation/:id" component={PicInvitationMock} />
//                 <PrivateRoute path="/liststatuses/:id" component={PicListStatuses} />
//                 <PrivateRoute path="/dashboard" component={DashboardPage} />
//                 <PrivateRoute path="/eventmanage/:value" component={PicEventMgtPage} />
//                 {/*
//                 <PrivateRoute path="/event/:id" component={PicEvent} /> */}
//                 <Route component={NotFoundPage} />
//             </Switch>
//         </div>
//       </ScrollToTop> 
//     </Router>
// );

export default AppRouter;


// WEBPACK FOOTER //
// ./src/routers/AppRouter.js